<template>
  <div class="nav-box">
    <div class="container nav">
        <ul>
          <li>
            <router-link to="/">首页</router-link>
          </li>
          <li>
            <router-link to="/notice">网站公告</router-link>
          </li>
          <li>
            <router-link to="/about">关于我们</router-link>
          </li>
          <li>
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.nav-box {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: $green;
  position: relative;
  color: #fff;
  font-size: 14px;
  a {
    color: #fff;
    text-decoration: none;
  }
  ul,li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  ul {
    display: flex;
    flex-direction: row;
  }
  li {
    padding: 0 40px;
  }
  
}

</style>